import { Component, OnInit } from '@angular/core';
import {ViewportScroller} from '@angular/common'
import {InvestorService} from '../investor.service';
import {Router} from '@angular/router';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import {Appconstants} from '../../../shared/app-constants';
// import { WindowUtils } from 'msal';
 import {environment} from '../../../../environments/environment.prod';
 import { ChangeDetectorRef } from '@angular/core';
 export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

declare function opensuccessModel();
@Component({
  selector: 'app-thingstodo',
  templateUrl: './thingstodo.component.html',
  styleUrls: ['./thingstodo.component.css']
})
export class ThingstodoComponent implements OnInit {
  getWindowEndDate: string;
  getFinanciarMessage: string;
  bln206ab: boolean=false;
  formDatahere: Object[]=[];
  getHeaderData: Object;
  get206abResidentMessage: string;
  getNonResident206abMessage: string;
  // ,private telemetryService:TelemetryService
  //constructor(private cdr: ChangeDetectorRef,private telemetryService:TelemetryService,private investorService : InvestorService, private vps: ViewportScroller,private router:Router) { }
  constructor(private cdr: ChangeDetectorRef,private investorService : InvestorService, private vps: ViewportScroller,private router:Router) { }
  headerData;
  formData : Object[]=[];
  TDSData;
  maskTDSData;
  selYear:string='';
  cycleName:string="";
  financialYearArr:string[]=[];
  cycleNameArr:string[]=[];
  formName:string = '';
  assessmentYear:string= "";
  primaryName:string;
  cycleFlag : boolean = false;
  pageLoad : boolean = true;
  blnSuccessPopup:boolean=false;
  blnTextMsgResidential:boolean=false;
  blnTextMsgNonResidential:boolean=false;
  windowFlag:boolean=false;
  windowStart:Date;
  windowEndDate:Date=new Date();
  windowEnd:Date=new Date();
  today:Date=new Date();
  financiarDate:string="";
  financiarMessage:string="";
  headersData:{assessment_year:string,createdby:string,createdby_date:string,cycle_description:string,
  cycle_id:string,cycle_name:string,isactive:string,window_start:string,window_end:string}[]=[];
   inputDownload: { cycle_id: any, document_type: any };
  ngOnInit() {
  if(sessionStorage.getItem("windowFlag")=="enable"){
    this.windowFlag=true;
  }
  console.log("window flag load",this.windowFlag);
   /*if(environment.telemetryFlg){
      let impressionEventData = {
        type: IMPRESSIONEVENTS.FORM,
        pageid: Appconstants.thingsToDoPageId,
        uri: window.location.href
      };
      this.telemetryService.impression(impressionEventData);
    }*/
    this.getWindowEndDate = environment.portalOpen; 
    this.getFinanciarMessage = environment.portalClose;
    this.get206abResidentMessage = environment.resident206ABNonCompliant; 
    this.getNonResident206abMessage = environment.nonResident206ABNonCompliant;
    this.getHeader();
    
    console.log("header",this.headerData);
  }

  showForm(formname){
    this.formName =formname;

    let telemetryEventData = {
      type: INTERACTEVENTS.CLICK,
      id: formname + "Clicked ",
      pageid: Appconstants.thingsToDoPageId
    }
   // this.telemetryService.interact(telemetryEventData);

  }

  scrollOnLoad(e){
    console.log("scrollOnLoad",e);
    
    if(e==true){
      this.scroll('tabView');
    }
  }


  changeCycleOnSelect(year){
    console.log("changeCycleOnSelect",this.selYear,year);
      this.assessmentYear=year['assessment_year'];
      this.cycleName=year['cycle_description'];
      this.windowStart=new Date(year['window_start']);
      this.windowStart.setHours(0,0,0,0);
      this.windowEndDate=new Date(year['window_end']);
      this.windowEnd.setTime(this.windowEndDate.getTime()+(24*60*60*1000));
      this.windowEnd.setHours(0,0,0,0);
      if(this.windowStart<=this.today && this.windowEnd>=this.today){
        this.windowFlag=true;
      }
      else{
        this.windowFlag=false;
        this.getDownloadTDSDetails();
        this.formName='';
      }
      if(year['isactive'] != '1'){
        this.cycleFlag = false;
        // this.getDownloadTDSDetails();
      }
      else{
        this.cycleFlag = true;
      }
  }

  getAssessmentYear(year){
    for(let FY of this.headerData['cycle_details']){
      if(year=== FY['cycle_name']){
        this.assessmentYear=FY['assessment_year'];
        this.cycleName=FY['cycle_description'];
        this.windowStart=new Date(FY['window_start']);
        this.windowStart.setHours(0,0,0,0);
        this.windowEndDate=new Date(FY['window_end']);
        this.windowEnd.setTime(this.windowEndDate.getTime()+(24*60*60*1000));
        this.windowEnd.setHours(0,0,0,0);
        if(this.windowStart<=this.today && this.windowEnd>=this.today){
          this.windowFlag=true;
        }
        else{
          this.windowFlag=false;
          this.getDownloadTDSDetails();
        }
        if(FY['isactive']=='1'){
          this.cycleFlag=true;
        }
        else{
          this.cycleFlag=false;
        }
        break;
      }

    }

  }

  getSelYear(){
    if(this.selYear=="" ){
      for(let FY of this.headerData['cycle_details']){
        this.windowStart=new Date(FY['window_start']);
        this.windowStart.setHours(0,0,0,0);
        this.windowEndDate=new Date(FY['window_end']);
        this.windowEnd.setTime(this.windowEndDate.getTime()+(24*60*60*1000));
         this.windowEnd.setHours(0,0,0,0);
        // console.log("FYDate"+FY['windowStart']);
        // console.log("Stored Date"+this.windowStart);
        // if(FY['isactive']=='1'){
        //   this.selYear=FY['cycle_name'];
        //   this.assessmentYear=FY['assessment_year'];
        //   this.cycleFlag=true;
        //   break;
        // }
        if(this.windowStart<=this.today && this.windowEnd>=this.today){
        //   console.log("window Start : "+this.windowStart);
        //   console.log("today's Date : "+this.today);
        //   console.log("window End : "+this.windowEnd);
          this.windowFlag=true;
        }
        else{
            this.windowFlag=false;
        }
        if(FY['isactive']=='1'){
          this.cycleFlag=true;
          this.selYear=FY['cycle_name'];
          this.assessmentYear=FY['assessment_year'];
          break;
        }
        else{
          this.cycleFlag=false;
        }
      }
      // this.headerData['financialYear'].map(ele=>{
      //   this.assessmentYear=ele['assessment_year'];
      //   // this.cycleName=ele['cycle_description'];
      //   if(ele['isactive']=='1' || ele['isactive']=='0'){
      //     this.selYear = ele['cycle_name'];
      //   }
      //   if(ele['isactive']=='1'){
      //     this.cycleFlag=true;
      //   }
      //   else{
      //     this.cycleFlag=false;
      //     this.getDownloadTDSDetails();
      //   }
      // });


    }
    return this.selYear;
  }

  getCycleName(){
    if(this.cycleName=="" ){
      for(let FY of this.headerData['cycle_details']){
        this.windowStart=new Date(FY['window_start']);
        this.windowStart.setHours(0,0,0,0);
        this.windowEndDate=new Date(FY['window_end']);
        this.windowEnd.setTime(this.windowEndDate.getTime()+(24*60*60*1000));
         this.windowEnd.setHours(0,0,0,0);
        if(FY['cycle_name']==this.selYear && FY['isactive']=='1'){
          this.cycleName=FY['cycle_description'];
          this.cycleFlag=true;
          if(this.windowStart<=this.today && this.windowEnd>=this.today){
            this.windowFlag=true;
          }
          else{
            this.windowFlag=false;
            this.getDownloadTDSDetails();
          }
          break;
        }
        else{
          this.cycleFlag=false;
        }
      }
      // this.headerData['financialYear'].map(ele=>{
      //   // this.assessmentYear=ele['assessment_year'];
        
      //   if(ele['isactive']=='1' || ele['isactive']=='0'){
      //     this.cycleName=ele['cycle_description'];
      //   }
        // if(ele['isactive']=='1'){
        //   this.cycleFlag=true;
        // }
        // else{
        //   this.cycleFlag=false;
        // }
      // });

    }
    return this.cycleName;
  }



  getForm(){
    this.investorService.getTaxForm().subscribe((data:Object[])=>{
      this.formDatahere=data
      if(this.bln206ab){
        this.formData = this.formDatahere;
      }
      else{
        for(let i of this.formDatahere){
          if(i['name']!="206AB Declaration"){
            console.log("monitor i", i, i['name'], this.bln206ab);
            this.formData.push(i);
          }
        }
      }
      console.log("formData", this.formData);
    },
    err => {
      console.log(err);
    })
  }

  getDownloadTDSDetails(){
    this.investorService.getAllDocByType('TDS',this.selYear,this.cycleName).subscribe((data)=>{
      this.TDSData = data['doc_list'];
      console.log("TDS Data"+this.maskTDSData);
      this.maskTDSData=data['doc_list'];
      console.log("tds data"+this.maskTDSData);
      for(var tds of this.maskTDSData){
        let docName=tds['documentName'];
        if(environment.maskingFlag==true){
          if(docName.length>30){
            tds['documentName']=docName.substring(0,2) + 'X'.repeat(6) + docName.substring(8,28)+'.'.repeat(3);
          }
          else{
            tds['documentName']=docName.substring(0,2) + 'X'.repeat(6) + docName.substring(8,docName.length);
          }
        }
        
      }
    },
    err => {
      console.log(err);
    })
  }


   fnDownloadTDSDocStatic(){   
    
   let CycleId= this.headersData.filter(x => x.assessment_year  === this.selYear && x.cycle_description === this.cycleName)[0]['cycle_id'];
    this.inputDownload = {
      "cycle_id": CycleId,
      "document_type": "TDS"
    }
    this.investorService.downloadTDSFile(this.inputDownload).subscribe(data => {    
      console.log("output",  data);
      let maskDocName=data['documentName'];
      if(environment.maskingFlag==true){
        maskDocName=maskDocName.substring(0,2) + 'X'.repeat(6) + maskDocName.substring(8,maskDocName.length);
      }
      this.base64ToFile(data['documentContent'],maskDocName);  
          /*if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: "DownloadDoc"+ " " + Appconstants.success,
              pageid: Appconstants.documentDownload
            }
            this.telemetryService.interact(telemetryEventData);
          }*/
      
    },err=>{
      console.log(err);    
      /*if(environment.telemetryFlg){
        let telemetryEventData = {
          type: INTERACTEVENTS.CLICK,
          id: "DownloadDoc"+ " " + Appconstants.failure+ err,
          pageid: Appconstants.documentDownload
        }
        this.telemetryService.interact(telemetryEventData);
      } */
    });    
  
  }
  fnDownloadTDSDoc(docName){
    // console.log("docType",this.docType)
    //let docAzureName=docName.split(':')[1];
    let docAzureName= docName;
    console.log("docAzureName",docAzureName)
    this.investorService.downloadFile(docAzureName).subscribe(data => {    
      console.log("output",  data);
      let maskDocName=data['documentName'];
      if(environment.maskingFlag==true){
        maskDocName=maskDocName.substring(0,2) + 'X'.repeat(6) + maskDocName.substring(8,maskDocName.length);
      }
      this.base64ToFile(data['documentContent'],maskDocName);  
         /* if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: "DownloadDoc"+ " " + Appconstants.success,
              pageid: Appconstants.documentDownload
            }
            this.telemetryService.interact(telemetryEventData);
          }*/
      
    },err=>{
      console.log(err);    
      /*if(environment.telemetryFlg){
        let telemetryEventData = {
          type: INTERACTEVENTS.CLICK,
          id: "DownloadDoc"+ " " + Appconstants.failure+ err,
          pageid: Appconstants.documentDownload
        }
        this.telemetryService.interact(telemetryEventData);
      } */
    });    
  }




  private base64ToFile(base64Data,docName) {
    console.log(base64Data,docName);
      let byteArray: Uint8Array;
      let blob: Blob;
      let filename: string;
      let byteCharacters = atob(base64Data);
      let byteNumbers = new Array(byteCharacters.length);
      let link: HTMLAnchorElement;
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray]);
  
      console.log(blob);
      if ((navigator as any).msSaveBlob) {
        filename = docName;
        (navigator as any).msSaveBlob(blob, filename);
      } else {
        link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute('visibility', 'hidden');
        link.download = docName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  





  getHeader(){
    this.investorService.getHeader().subscribe((data)=>{
      this.getHeaderData = data;
   //   console.log('getHeader',data);
      if(!(data['other_doctypes']==undefined && data['other_doctypes'] == null)){

        if(data['other_doctypes']=='206AB'){
          this.bln206ab=true;
        }
        else {
          this.bln206ab=false;
        }
      }
      ////
      this.headerData = data;
      this.pageLoad = false;
      for(let fy of this.headerData['cycle_details']){
        if(this.financialYearArr.includes(fy['cycle_name']) === false){
          this.financialYearArr.push(fy['cycle_name']);
        }
      }
    
      for(let i in this.headerData['cycle_details']){
     //   console.log('loopingheaderdata',this.headerData['cycle_details'][i]);

        this.headersData.push({assessment_year:this.headerData['cycle_details'][i]['assessment_year'],
        createdby:this.headerData['cycle_details'][i]['createdby'],
        createdby_date:this.headerData['cycle_details'][i]['createdby_date'],
        cycle_description:this.headerData['cycle_details'][i]['cycle_description'],
          cycle_id:this.headerData['cycle_details'][i]['cycle_id'],
          cycle_name:this.headerData['cycle_details'][i]['cycle_name'],
          isactive:this.headerData['cycle_details'][i]['isactive'],
          window_start:this.headerData['cycle_details'][i]['window_start'],
          window_end:this.headerData['cycle_details'][i]['window_end']})
      }
      this.financialYearArr=   this.financialYearArr.sort((a,b) => 0 - (a > b ? -1 : 1));
      //this.financiarDate = 
      console.log("FY",this.financialYearArr);
      console.log("DC",this.cycleNameArr);
      console.log("this.headersData",this.headersData);
      this.financiarMessage=this.headersData.filter(x => x.isactive  === "1")[0]['cycle_description'];
      //this.financiarDate
   //   console.log(this.headersData.filter(x => x.isactive  === "1")[0]['assessment_year'])
   //    console.log(this.headersData.filter(x => x.isactive  === "1")[0]['cycle_description'])

      this.primaryName = this.headerData['userName'];
      let str = this.headerData['userName'];
      let strWS = str.replace(' ', '');
      if(str.length>=6){
        this.primaryName = strWS.substring(0, 3) + 'X'.repeat(strWS.length - 6) + strWS.substring(strWS.length - 3, strWS.length);
      }
      // if (this.headerData['isCycleAtive'] == '1') {
      //   this.cycleFlag = true;
      // }
      // else{
      //   this.cycleFlag = false;
      // }
      this.cdr.detectChanges();
    },
    err => {
      console.log(err);
      this.pageLoad = true;
    })
    setTimeout(() => {
    this.getForm();     
    }, 500);
  }

  scroll(id) {
    console.log("inclick", id);
    this.vps.scrollToAnchor(id)
  }

  closeModalPopup(){
    this.blnSuccessPopup=false;
     if(isIE==true){
         console.log("insideIE",isIE);
        window.location.reload(); 
     }
   
  }


  successform(pagesubmited:any){
    console.log('pagesubmitted',pagesubmited);
      if (pagesubmited=='RESIDENT'){
        this.blnTextMsgResidential=true;
        this.blnTextMsgNonResidential=false;
      }
      else if(pagesubmited=='NONRESIDENT'){
        this.blnTextMsgNonResidential=true;
        this.blnTextMsgResidential=false;
      }
      
      this.blnSuccessPopup=true;
      opensuccessModel();
  }

  gotoPage(){
    this.router.navigate(['app-home/investor/termsNCondition']);
  }
}
